/**
 * CareSessionTypeService
 * Service for managing the care session type catalog
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for care session type catalog CRUD operations
 */
export class CareSessionTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CareSessionTypeService.DEFAULT_SERVICE_PATH,
            basePath: CareSessionTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CareSessionTypeService.DEFAULT_SERVICE_PATH = 'ac-counselling';
CareSessionTypeService.BASE_PATH = 'api/care-session-types';
//# sourceMappingURL=CareSessionTypeService.js.map